import React from 'react';
import { CATEGORIES } from '../mock';
import { ArrowUpRight } from 'lucide-react';

export default function Categories() {
  return (
    <section id="categorias" className="relative w-full py-24 md:py-32 bg-[color:var(--sd-bg)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-baseline justify-between">
          <h2 className="font-display font-black text-white text-3xl md:text-5xl tracking-widest">
            CATEGORIAS
          </h2>
          <div className="text-xs tracking-[0.3em] text-[color:var(--sd-cyan)]/70 font-mono hidden md:block">
            [ 07 SISTEMAS ATIVOS ]
          </div>
        </div>
        <div className="sd-rule mt-4 mb-12" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {CATEGORIES.map((c) => (
            <article
              key={c.id}
              className={`sd-panel sd-brackets group p-5 md:p-6 flex flex-col min-h-[380px] ${
                c.featured ? 'md:col-span-2 lg:col-span-3 md:flex-row md:gap-8 md:items-stretch' : ''
              }`}
            >
              {c.featured ? (
                <>
                  <div className="md:w-1/2 lg:w-2/5 flex flex-col">
                    <div className="flex items-start justify-between mb-4">
                      <h3 className="font-display font-bold text-[color:var(--sd-cyan)] text-lg md:text-xl tracking-[0.15em] pr-3">
                        {c.title}
                      </h3>
                      <span className="text-[color:var(--sd-cyan)]/80 text-xs tracking-[0.3em] font-mono shrink-0">
                        [{c.id}]
                      </span>
                    </div>
                    <div className="relative overflow-hidden aspect-[16/10] border border-[rgba(34,230,230,0.2)] bg-gradient-to-br from-white via-slate-100 to-slate-200">
                      <img
                        src={c.image}
                        alt={c.title}
                        className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
                      />
                    </div>
                  </div>
                  <div className="md:w-1/2 lg:w-3/5 flex flex-col mt-5 md:mt-0">
                    <div className="hidden md:flex items-center gap-2 mb-4">
                      <span className="text-[10px] tracking-[0.3em] text-[color:var(--sd-cyan)]/70 font-mono">
                        // BLOCO DESTAQUE
                      </span>
                      <span className="h-px flex-1 bg-[rgba(34,230,230,0.25)]" />
                    </div>
                    <p className="text-sm md:text-[15px] text-[color:var(--sd-text)]/85 font-mono leading-relaxed">
                      {c.description}
                    </p>
                    <div className="mt-6 flex flex-wrap gap-3">
                      {['PIX', 'CARTÃO', 'BALCÃO DO BAR', 'PACKS BAR', 'PREMIUM'].map((tag) => (
                        <span
                          key={tag}
                          className="px-3 py-1.5 text-[11px] tracking-[0.25em] font-mono text-[color:var(--sd-cyan)] border border-[rgba(34,230,230,0.4)]"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                    <div className="mt-auto pt-6 flex items-center justify-between">
                      <span className="text-[10px] tracking-[0.3em] text-[color:var(--sd-cyan)]/70 font-mono">
                        // {c.id}.NODE
                      </span>
                      <button className="flex items-center gap-2 text-[color:var(--sd-cyan)] text-xs tracking-[0.25em] font-mono hover:gap-3 transition-all">
                        SABER MAIS <ArrowUpRight size={14} />
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex items-start justify-between mb-4">
                    <h3 className="font-display font-bold text-[color:var(--sd-cyan)] text-lg tracking-[0.15em] pr-3">
                      {c.title}
                    </h3>
                    <span className="text-[color:var(--sd-cyan)]/80 text-xs tracking-[0.3em] font-mono shrink-0">
                      [{c.id}]
                    </span>
                  </div>
                  <div className="relative overflow-hidden aspect-[16/10] border border-[rgba(34,230,230,0.2)] bg-gradient-to-br from-white via-slate-100 to-slate-200">
                    <img
                      src={c.image}
                      alt={c.title}
                      className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050608]/60 via-transparent to-transparent" />
                  </div>
                  <p className="mt-5 text-sm text-[color:var(--sd-text)]/75 font-mono leading-relaxed">
                    {c.description}
                  </p>
                  <div className="mt-auto pt-5 flex items-center justify-between">
                    <span className="text-[10px] tracking-[0.3em] text-[color:var(--sd-cyan)]/70 font-mono">
                      // {c.id}.NODE
                    </span>
                    <button className="flex items-center gap-2 text-[color:var(--sd-cyan)] text-xs tracking-[0.25em] font-mono hover:gap-3 transition-all">
                      EXPLORAR <ArrowUpRight size={14} />
                    </button>
                  </div>
                </>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
